import { useState } from "react";
import { X } from "@phosphor-icons/react";
import { usePromotion } from "./usePromotion";

export default function PromotionStrip() {
  const promo = usePromotion("infostrip");
  const [dismissed, setDismissed] = useState(false);

  if (!promo || dismissed) return null;

  return (
    <div className="relative z-[49] overflow-hidden border-b border-primary-700">
      <div
        className="flex items-center justify-center gap-2 px-8 pr-10 py-2 text-xs sm:text-sm text-white"
        style={{
          background:
            "linear-gradient(270deg, #1a3dba, #3b69fc, #2250e0, #6385fc, #1a3dba)",
          backgroundSize: "300% 100%",
          animation: "promo-slide 6s ease infinite",
        }}
      >
        {/* pulsing dot */}
        <span className="relative flex h-2 w-2 shrink-0">
          <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
        </span>

        <span className="text-center font-medium leading-tight tracking-wide min-w-0 truncate sm:whitespace-normal sm:overflow-visible">
          {promo.text}
        </span>

        {promo.actionUrl && promo.actionButtonText && (
          <a
            href={promo.actionUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 rounded-full bg-white px-2.5 py-0.5 text-xs font-bold text-primary hover:bg-primary-50 transition-colors shadow-sm hidden sm:inline-flex"
          >
            {promo.actionButtonText} →
          </a>
        )}
      </div>

      <button
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-0.5 text-white/70 hover:bg-white/20 hover:text-white transition-colors"
      >
        <X size={13} weight="bold" />
      </button>

      <style>{`
        @keyframes promo-slide {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
    </div>
  );
}
